import { getFilterMetadata } from '../../../../components/StatelessComponent/FilterChainUtils';
import { readableRadioNumberOperations } from '../../../../components/StatelessComponent/SingleFilter/GenericBloc/GenericRadioNumberFilter/GenericRadioNumberDropdown';
import type {
  RadioNumberFilterValue,
  RadioNumberFilterValueType,
} from '../../../../components/StatelessComponent/SingleFilter/GenericBloc/GenericRadioNumberFilter/GenericRadioNumberType';
import { RadioNumberFilterOperationsWithoutSpecificValue } from '../../../../components/StatelessComponent/SingleFilter/GenericBloc/GenericRadioNumberFilter/GenericRadioNumberType';
import type { FilterKindEnum } from '../../../../domains/global-filters/model/FilterChain';
import type { LabelProps } from '../../LabelFormatterType';

export const getValueLabel = (value: RadioNumberFilterValueType): string => {
  if (!value) {
    return '';
  }
  if (
    'value' in value &&
    !RadioNumberFilterOperationsWithoutSpecificValue.includes(value.operation)
  ) {
    return `${readableRadioNumberOperations[value.operation]} "${value.value}"`;
  }
  if ('from' in value && 'to' in value) {
    return `${readableRadioNumberOperations[value.operation]} "${value.from}" and "${value.to}"`;
  }
  return readableRadioNumberOperations[value.operation];
};

export function getLabels(
  currentValue: RadioNumberFilterValue | undefined,
  filterKind: FilterKindEnum,
): LabelProps {
  const metadata = getFilterMetadata(filterKind);
  return {
    label1: metadata.filterName,
    label2: getValueLabel(currentValue),
  };
}
